import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

import { ViewUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Menu from 'PMT/entities/menu/Menu';

// -- views
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';
import RowPricesView from 'components/order/RowPricesView';
import SortableList from 'PMT/components/SortableList';
import ImageLoader from 'PMT/components/ImageLoader';

class CategoryDetailMenuRow extends Component {

  static propTypes = {
    menu: PropTypes.instanceOf(Menu).isRequired,
    currencyCode: PropTypes.string,


    // parameters: Menu
    onDeleteFromCategory: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.menu.equals(this.props.menu);
  }

  onDisplayDetail = () => {
    RouteAction.presentMenuDetail(this.menu);
  };

  onDeleteFromCategory = () => {
    this.props.onDeleteFromCategory(this.props.menu);
  };

  get menu() {
    return this.props.menu;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }


  renderAvailabilities() {
    return (
      <RowPricesView
        prices={this.menu.prices}
        currencyCode={this.currencyCode}
      />
    );
  }

  render() {
    return (
      <div className="product_category_view__row pointer row">

        <div className="hidden-sm col-md-2 text-left">
          <ImageLoader
            src={this.menu.image}
            className="product_category_view__row__image"
            placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_MENU}
          />
        </div>

        <div
          className="menu__name col-xs-6 product_category_view__row__name"
          onClick={this.onDisplayDetail}
        >
          <h4>{this.menu.name}</h4>
        </div>

        <div
          className="pointer col-xs-2 text-right"
          onClick={this.onDisplayDetail}
        >
          {this.renderAvailabilities()}
        </div>

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__remove"
            onClick={this.onDeleteFromCategory}
          >
            <i className="fa fa-trash" />
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__drag"
          >
            <SortableList.DragHandle />
          </div>
        }
      </div>
    );
  }

}

export default CategoryDetailMenuRow;
